import * as React from "react";
import { BusinessReportOutcome } from "@/modules/snapshots/businessReports.types";
import { SnapshotCollectionsOutcomesSearchHeader } from "./header";
import { SnapshotCollectionsOutcomesSearchRow } from "./row";

interface Props {
  snapshotCollectionOutcomes: BusinessReportOutcome[];
}

export const SnapshotCollectionsOutcomesSearchResults: React.FC<Props> = ({ snapshotCollectionOutcomes }) => (
  <div className="overflow-hidden shadow ring-1 ring-black/5 sm:rounded-lg">
    <table className="min-w-full divide-y divide-gray-300">
      <SnapshotCollectionsOutcomesSearchHeader total={snapshotCollectionOutcomes.length} />
      <tbody className="divide-y divide-gray-200 bg-white">
        {snapshotCollectionOutcomes.map(businessReportOutcome => (
          <SnapshotCollectionsOutcomesSearchRow
            businessReportOutcome={businessReportOutcome}
            key={businessReportOutcome.id}
          />
        ))}
      </tbody>
    </table>
  </div>
);
